import { useQuery, QueryObserverOptions } from 'react-query';
import { HTTPError, Customer } from 'types';
import { getQueryAsync } from 'api/api-client';
import { useAppContext } from 'context/app/app-context';

const getCustomers = async (tenantId: string) => {
    return getQueryAsync<Customer[]>(
        `/Customers?Filter=tenant eq '${tenantId}'&Sort=name`
    );
};

export default function useCustomers(
    options?: QueryObserverOptions<Customer[], HTTPError>
) {
    const {
        state: { tenant }
    } = useAppContext();

    return useQuery<Customer[], HTTPError>(
        ['Customers', tenant.id],
        () => getCustomers(tenant.id),
        { ...options, enabled: Boolean(tenant.id) }
    );
}